import axios from 'axios';

// Configure axios defaults
// Use relative URL to ensure requests go through the same protocol as the page
axios.defaults.baseURL = '';
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Add request interceptor to add auth token
axios.interceptors.request.use(
  (config) => {
    // Check for token in multiple possible keys for compatibility
    const token = localStorage.getItem('access_token') || localStorage.getItem('token') || localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't process aborted requests
    if (error.code === 'ECONNABORTED' || error.code === 'ERR_CANCELED') {
      return Promise.reject(error);
    }
    
    if (error.response?.status === 401) {
      // Don't automatically redirect - let the app handle it
      // This prevents circular redirects
      const currentPath = window.location.pathname;
      
      // Only clear auth and redirect if we're not already on the login page
      // and not in the middle of auth operations
      if (currentPath !== '/login' && !error.config?.url?.includes('/user-auth/')) {
        // Don't clear auth here - let authService handle it
        // This prevents race conditions with refresh token
        console.warn('401 error detected, auth service will handle it');
      }
    }
    return Promise.reject(error);
  }
);

export default axios;